// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1r2iC","label":"SetPasswdForm_label__65qxc"};